import { Application } from "@hotwired/stimulus";

import BouncerController from "./bouncer_controller";
import BouncerTicketController from "./bouncer_ticket_controller";
import ChatMediaController from "./chat_media_controller";
import AvatarMenuController from "./avatar_menu_controller";
import AutoSubmitController from "./auto_submit_controller";
import ChewPaymentController from "./chew_payment_controller";
import ChannelKeyController from "./channel_key_controller";
import ChannelInviteSearchController from "./channel_invite_search_controller";
import ChannelAirdropController from "./channel_airdrop_controller";
import ChannelComposeController from "./channel_compose_controller";
import ChannelBubbleContentController from "./channel_bubble_content_controller";
import ChatScrollController from "./chat_scroll_controller";
import ClipboardController from "./clipboard_controller";
import CopyTextController from "./copy_text_controller";
import DailyVideoController from "./daily_video_controller";
import TimeSplitController from "./time_split_controller";
import TimeWorksiteController from "./time_worksite_controller";
import DetroitClockController from "./detroit_clock_controller";
import DecryptController from "./decrypt_controller";
import EcdhController from "./ecdh_controller";
import EncryptSubmitController from "./encrypt_submit_controller";
import FlickerController from "./flicker_controller";
import GoController from "./go_controller";
import InvoiceController from "./invoice_controller";
import IdleTimeoutController from "./idle_timeout_controller";
import LocationController from "./location_controller";
import LoadingOverlayController from "./loading_overlay_controller";
import NationLocationController from "./nation_location_controller";
import NostrAuthController from "./nostr_auth_controller";
import QrCodeController from "./qr_code_controller";
import RecordSubmitController from "./record_submit_controller";
import ScannerController from "./scanner_controller";
import PowWowPayController from "./pow_wow_pay_controller";
import PowWowOrderController from "./pow_wow_order_controller";
import UserSearchController from "./user_search_controller";
import PowWowVendorSearchController from "./pow_wow_vendor_search_controller";
import VoiceController from "./voice_controller";
import VoiceboxController from "./voicebox_controller";
import VoicePlaybackController from "./voice_playback_controller";
import WaveformController from "./waveform_controller";
import SearchController from "./search_controller";
import RadioplayerController from "./radioplayer_controller";
import LongplayRequestController from "./longplay_request_controller";
import LongplayRequestWireController from "./longplay_request_wire_controller";
import RecaptchaController from "./recaptcha_controller";
import CoverArtController from "./cover_art_controller";
import BridgeBuilderController from "./bridge_builder_controller";
import CrossingTicketController from "./crossing_ticket_controller";
import CurrencyConverterController from "./currency_converter_controller";
import ExchangeController from "./exchange_controller";
import ExchangeProcessingController from "./exchange_processing_controller";
import ExtraBuilderController from "./extra_builder_controller";
import SmsOptController from "./sms_opt_controller";
import SipsController from "./sips_controller";
import ThumperMonitorController from "./thumper_monitor_controller";
import ThingUnitsController from "./thing_units_controller";
import ZombieMediaController from "./zombie_media_controller";
import ZombieCoinLookupController from "./zombie_coin_lookup_controller";

import TimePunchResultController from "./time_punch_result_controller";
import TimeclockController from "./timeclock_controller";
import TimekeepingClockController from "./timekeeping_clock_controller";

const application = Application.start();
application.register("time-punch-result", TimePunchResultController);
application.register("timeclock", TimeclockController);
application.register("timekeeping-clock", TimekeepingClockController);

application.register("bouncer", BouncerController);
application.register("bouncer-ticket", BouncerTicketController);
application.register("chat-media", ChatMediaController);
application.register("avatar-menu", AvatarMenuController);
application.register("auto-submit", AutoSubmitController);
application.register("chew-payment", ChewPaymentController);
application.register("channel-key", ChannelKeyController);
application.register("channel-invite-search", ChannelInviteSearchController);
application.register("channel-airdrop", ChannelAirdropController);
application.register("channel-compose", ChannelComposeController);
application.register("channel-bubble-content", ChannelBubbleContentController);
application.register("chat-scroll", ChatScrollController);
application.register("clipboard", ClipboardController);
application.register("copy-text", CopyTextController);
application.register("daily-video", DailyVideoController);
application.register("time-split", TimeSplitController);
application.register("time-worksite", TimeWorksiteController);
application.register("detroit-clock", DetroitClockController);
application.register("decrypt", DecryptController);
application.register("ecdh", EcdhController);
application.register("encrypt-submit", EncryptSubmitController);
application.register("flicker", FlickerController);
application.register("go", GoController);
application.register("invoice", InvoiceController);
application.register("idle-timeout", IdleTimeoutController);
application.register("location", LocationController);
application.register("loading-overlay", LoadingOverlayController);
application.register("nation-location", NationLocationController);
application.register("nostr-auth", NostrAuthController);
application.register("qr-code", QrCodeController);
application.register("record-submit", RecordSubmitController);
application.register("scanner", ScannerController);
application.register("pow-wow-pay", PowWowPayController);
application.register("pow-wow-order", PowWowOrderController);
application.register("user-search", UserSearchController);
application.register("pow-wow-vendor-search", PowWowVendorSearchController);
application.register("voice", VoiceController);
application.register("voicebox", VoiceboxController);
application.register("voice-playback", VoicePlaybackController);
application.register("waveform", WaveformController);
application.register("search", SearchController);
application.register("recaptcha", RecaptchaController);
application.register("radioplayer", RadioplayerController);
application.register("longplay-request", LongplayRequestController);
application.register("longplay-request-wire", LongplayRequestWireController);
application.register("cover-art", CoverArtController);
application.register("bridge-builder", BridgeBuilderController);
application.register("crossing-ticket", CrossingTicketController);
application.register("currency-converter", CurrencyConverterController);
application.register("exchange", ExchangeController);
application.register("exchange-processing", ExchangeProcessingController);
application.register("extra-builder", ExtraBuilderController);
application.register("sms-opt", SmsOptController);
application.register("sips", SipsController);
application.register("thumper-monitor", ThumperMonitorController);
application.register("thing-units", ThingUnitsController);
application.register("zombie-media", ZombieMediaController);
application.register("zombie-coin-lookup", ZombieCoinLookupController);

window.application = application;
